import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue';
import VueResource from 'vue-resource';
import i18n from './i18n'
import router from './routes/index.js';
import store from './store/index.js';
import config from './config/config.js';
import * as Cookies from 'js-cookie';
import {mapActions} from 'vuex';
import VModal from 'vue-js-modal';


//seta debug
window.debug = config.debug;

Vue.use(VModal, { dialog: true });

Vue.use(VueResource, Vuex);

Vue.http.options.root = process.env.API_URL ? process.env.API_URL : config.api.endpoint;

Vue.http.interceptors.push((req, next) => {
  //seta informacoes no header
  req.headers.set('Authorization', store.state.usuario.session.idToken);
  next(function(response){
    if(response.body.message == "The incoming token has expired"){
      router.push({ name: 'login', params: { errorMessage: i18n.t('rotas.label.token-undefined')} });
      $('#loading').modal('hide');
    }
  });

});

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
  methods: {
	  ...mapActions({
      logoutCleanInfoUser: 'cleanInfoUser'
    }),
    
  },
  created () {
  },

})

$(".modal").on("shown.bs.modal", function () {
  if ($(".modal-backdrop").length > 1) {
      $(".modal-backdrop").remove();
  }
})


// WEBPACK FOOTER //
// ./src/main.js